import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTheme } from "../functions/themeService/themeService";
import { useIsMobile } from "../functions/deviceIdentity/getDeviceType";
import { Capacitor } from "@capacitor/core";
import { getItem } from "../utils/storageHelper";

const Welcome = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(true);
    const theme = getTheme();
    const isMobile = useIsMobile();

    useEffect(() => {
        const checkExistingSession = async () => {
            const firebaseUser = Capacitor.isNativePlatform()
                ? await getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`)
                : localStorage.getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`);

            if (!firebaseUser) {
                return;
            }

            const storedSettings = Capacitor.isNativePlatform()
                ? await getItem(`usersettings:${import.meta.env.VITE_PUBLIC_APP_ENV}`)
                : localStorage.getItem(`usersettings:${import.meta.env.VITE_PUBLIC_APP_ENV}`);

            if (storedSettings) {
                try {
                    const settings = JSON.parse(storedSettings);
                    switch (settings.defaultView) {
                        case 'overview':
                            navigate('/Overview');
                            break;
                        case 'dueDates':
                            navigate('/Due-dates');
                            break;
                        case 'todo':
                            navigate('/Todo');
                            break;
                        case 'calendar':
                            if (Capacitor.isNativePlatform()) {
                                navigate('/Overview');
                            } else {
                                navigate('/Calendar');
                            }
                            break;
                        default:
                            navigate('/Overview');
                            break;
                    }
                } catch {
                    navigate('/Overview');
                }
            } else {
                navigate('/Overview');
            }
        };

        checkExistingSession();
    }, [navigate]);

    const handleSupportPage = () => {
        window.open('https://support.texthelp.com/help/globaltasks', '_blank', 'noopener,noreferrer');
    };

    const handleTandCPolicy = () => {
        window.open(`${import.meta.env.VITE_DEVICE_DOMAIN}TermsAndConditions.html`, '_blank', 'noopener,noreferrer');
    };

    const handleWhatIsGt = () => {
        window.open('https://www.everway.com/en-gb/govt-grant-schemes/global-tasks', '_blank', 'noopener,noreferrer');
    };

    const handlePrivacyPolicy = () => {
        window.open(`${import.meta.env.VITE_DEVICE_DOMAIN}PrivacyPolicy.html`, '_blank', 'noopener,noreferrer');
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const pwaCanInstall = 'standalone' in window.navigator;
    const pwaIsInstalled = window.navigator.standalone === true;

    return (
        <div className="gt-container th-gt" >
            <>
                <header className="gt-header">
                    <div className="gt-header__logo">
                        <svg className="gt-logo" xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref="#globaltasks-svg-logo-icon"></use>
                            <use xlinkHref={theme ? theme === 'light' ? '#globaltasks-svg-logo' : '#globaltasks-svg-logo-dark' : '#globaltasks-svg-logo'}></use>
                        </svg>
                    </div>
                    <button type="button" className="gw-button gw-button--secondary"
                        onClick={() => { handleSupportPage(); }}
                    >
                        Support
                    </button>
                </header>

                <div className="gt-content gt-content__intro">
                    <div className="gt-intro">
                        <h1>Welcome to Global Tasks!</h1>
                        <p>See the big picture, hide the noise and focus on your priorities.</p>

                        <button type="button" className="gw-button gw-button--s3 gw-button--primary" onClick={() => navigate('/Login')}>Sign In</button>
                    </div>

                    <div className="gt-intro__aside gt-desktop-only">
                        <div className="gt-task">
                            <div className="gt-task__color" style={{ background: "#80C3E9" }}></div>
                            <input className="gt-task__completed" type="checkbox" aria-label="Task completed?" defaultChecked />

                            <p className="gt-task__title">Sign in</p>
                            <button className="gw-icon-button gw-icon-button--icon" aria-label="more">
                                <i className="gw-icon-button__icon gw-button__icon--more"></i>
                            </button>
                        </div>

                        <div className="gt-task">
                            <div className="gt-task__color" style={{ background: "#D6C772" }}></div>
                            <input className="gt-task__completed" type="checkbox" aria-label="Task completed?" />
                            <p className="gt-task__title">Redeem my code</p>
                            <button className="gw-icon-button gw-icon-button--icon" aria-label="more">
                                <i className="gw-icon-button__icon gw-button__icon--more"></i>
                            </button>
                        </div>

                        <div className="gt-task">
                            <div className="gt-task__color" style={{ background: "#3D9F8E" }}></div>
                            <input className="gt-task__completed" type="checkbox" aria-label="Task completed?" />
                            <p className="gt-task__title">Get started!</p>
                            <button className="gw-icon-button gw-icon-button--icon" aria-label="more">
                                <i className="gw-icon-button__icon gw-button__icon--more"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </>

            {!isMobile && (
            <div className="gw-settings-body__button-area">
                    <div className="gw-group gw-group--align-right">
                        <button className="gw-button gw-link gw-button--link gw-button--link--small" style={{ color: "black" }}
                            onClick={() => { handleWhatIsGt(); }}>
                            What is Global Tasks?
                        </button> |
                    <button className="gw-button gw-link gw-button--link gw-button--link--small" style={{color:"black"} }
                        onClick={() => { handleTandCPolicy(); }}>
                        User Terms
                    </button> |
                    <button className="gw-button gw-link gw-button--link gw-button--link--small" style={{ color: "black" }}
                        onClick={() => { handlePrivacyPolicy(); }}>
                        Privacy Policy
                    </button>
                </div>
                </div>
            )}
        </div>)

};

export default Welcome;
